import { useCallback, useEffect, useState } from "react";
import api from "./api";
import { useApp } from "../context/AppContext";

// Single source of truth for the current workspace's plan/limits/usage + checkout.
export function useBilling() {
  const { user } = useApp();
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setBilling(null); return; }
    setLoading(true);
    try {
      const { data } = await api.get("/billing/me");
      setBilling(data);
    } catch {
      /* keep previous */
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  // Redirect to Stripe Checkout. Amount is server-authoritative; we only send plan + cycle.
  const startCheckout = useCallback(async (planId, cycle = "monthly") => {
    const { data } = await api.post("/billing/checkout", {
      plan_id: planId, cycle, origin_url: window.location.origin,
    });
    if (data?.url) window.location.href = data.url;
    return data;
  }, []);

  return { billing, loading, refresh, startCheckout };
}
